import { Control } from "react-hook-form";

import { KeywordSelect } from "components/form_components/keyword_select/KeywordSelect";
import { DocumentFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface KeywordsFilterContentProps {
  control: Control<DocumentFilters, unknown>;
}

function KeywordsFilterContent({ control }: KeywordsFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Keywords filters">
      <KeywordSelect name="keywords" label="Keywords" control={control} />
    </div>
  );
}

export default KeywordsFilterContent;
